import { GET_ROSTER, LOG_OUT } from './bridge-methods';
import { getRosterData } from './roster/selectors';
import { addOrUpdateClass } from '../redux-known-classes/known-class-actions';
import { afterLogOut } from '../redux-route/route-actions';

export const methods = {
  [GET_ROSTER]: [tryAddRosterToLocalStorage()],
  [LOG_OUT]: [afterLogOut()],
};

export function tryAddRosterToLocalStorage() {
  return function(dispatch, getState) {
    const roster = getRosterData(getState());
    dispatch(addOrUpdateClass(roster.code, roster.name));
  };
}
